import { put, select, takeLatest } from 'redux-saga/effects';
import { commonActions, commonSelectors } from '../../common';
import { takeConfirmation } from '../../utils/sagas';

const cancelTourSaga = takeLatest(commonActions.cancelTour.request.type, function* (
  action: ReturnType<typeof commonActions.cancelTour.request>
) {
  const { tourCode, onConfirmed } = action.payload;

  const confirmed: boolean = yield takeConfirmation({
    content: {
      key: 'my_tours.cancel_confirmation_description',
    },
    positiveKey: 'my_tours.cancel_confirmation_confirm',
    negativeKey: 'my_tours.cancel_confirmation_reject',
  });

  if (!confirmed) return;

  yield put(commonActions.clearAssetCache(tourCode));

  onConfirmed && onConfirmed();

  const tourProgresses = commonSelectors.selectRunningTourProgresses(yield select());
  const stopIndex = tourProgresses[tourCode]?.playbook?.currentPage?.stopIndex ?? -1;
  yield put(commonActions.cancelTour.confirmed({ tourCode, tourStop: stopIndex + 1 }));
});

const sagas = [cancelTourSaga];

export default sagas;
